import React from 'react'
import './banner.scss'
import images from './index.js'
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const banner = () => {

    const settings = {
        dots: true,
        arrows: true,
        infinite: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 768, // Adjust breakpoint for your mobile size
            settings: {
              slidesToShow: 1, // Show only 1 slide on mobile screens
            }
          }
        ]
      };

    return (
    <div className='banner'>
         <div>
       
         <Slider {...settings}>
         {images.map((image, index) => (
            <div >
           
                <img  className='image-banner'key={index} src={image} />
           
            </div>
            ))}
            </Slider>
         </div>
    </div>
  )
}

export default banner;